import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { Fact } from '@/api/types/backend-dto-types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useGetDocFactsV2 = (
  matterId: string | null | undefined,
  subsetId: string | null | undefined,
  docId: string | null | undefined,
) => {
  const { getFetchConfig } = useGetFetchConfig();
  const fetchConfigPOST = getFetchConfig({
    method: FetchMethod.GET,
  });

  return useQuery<Fact[], Error>(
    [QueryEntity.CaseFacts, { docId }],
    async () => {
      const response = await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/subsets/${subsetId}/docs/${docId}/facts`,
        fetchConfigPOST,
      );
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    },
    { refetchOnWindowFocus: false, enabled: !!matterId && !!subsetId && !!docId },
  );
};
